import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import AppointmentForm from "./AppointmentForm";
import { Modal } from "antd";

function Calendar({ data }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [eventDetails, setEventDetails] = useState(null);
  const [showAppointmentForm, setShowAppointmentForm] = useState(false);

  // Handle calendar date selection
  const handleSelect = (info) => {
    try {
      const date = info.startStr;
      console.log("Selected date:", date);
      setSelectedDate(date);
      setEventDetails(null);
      setShowAppointmentForm(true); // Show appointment form instead of modal
    } catch (error) {
      console.error("Error handling select:", error);
    }
  };

  // Handle clicking on an event to show details
  const handleEventClick = (info) => {
    const event = info.event;
    setEventDetails({
      title: event.title,
      start: event.start.toISOString(),
      contact: event.extendedProps.contact || "No phone available",
      service: event.extendedProps.service || "No service specified",
      end: event.end ? event.end.toISOString() : "Not specified",
      description: event.extendedProps.description || "No details provided",
    });
    setSelectedDate(null);
    setIsModalVisible(true); // Show event details modal
  };

  // Close event details modal
  const handleModalCancel = () => {
    console.log("Closing event details modal from Calendar");
    setIsModalVisible(false);
    setEventDetails(null);
  };

  // Close appointment form
  const handleAppointmentFormCancel = () => {
    console.log("Closing appointment form from Calendar");
    setShowAppointmentForm(false);
    setSelectedDate(null);
  };

  // Handle appointment form submission
  const handleAppointmentFormOk = (values) => {
    console.log("Appointment form values submitted:", values);
    setShowAppointmentForm(false);
    setSelectedDate(null);
  };

  return (
    <div>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView={"dayGridMonth"}
        themeSystem="Journal"
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        height={"75vh"}
        selectable={true}
        select={handleSelect}
        events={data}
        eventClick={handleEventClick}
      />
      
      {/* Event Details Modal */}
      <Modal
        title="Event Details"
        open={isModalVisible}
        onCancel={handleModalCancel}
        footer={null} 
        width={600} 
        destroyOnClose={true} 
      >
        {eventDetails && (
          <div>
            <p><strong>Title:</strong> {eventDetails.title}</p>
            <p><strong>Date:</strong> {eventDetails.start}</p>
            <p><strong>Contact:</strong> {eventDetails.contact}</p>
            <p><strong>Service:</strong> {eventDetails.service}</p>
            <p><strong>End:</strong> {eventDetails.end}</p>
            <p><strong>Description:</strong> {eventDetails.description}</p>
          </div>
        )}
      </Modal>

      {/* Appointment Form - Rendered as its own modal */}
      <AppointmentForm
        visible={showAppointmentForm}
        onCancel={handleAppointmentFormCancel}
        selectedDate={selectedDate}
        onOk={handleAppointmentFormOk}
      />
    </div>
  );
}

export default Calendar;